import { formatCurrency } from '@/utils';
import {Skeleton} from '@/components/ui/skeleton'
import { ReceiptText, CircleDollarSign, Coins, HandCoins, Handshake, Receipt } from 'lucide-react';

const TILES = {
    paid: { title: 'Paid', icon: <CircleDollarSign className='size-4' />, hint: 'Payments and settlements received on invoices.' },
    due: { title: 'Due', icon: <HandCoins className='size-4' />, hint: 'Still owed on approved and billed invoices.' },
    billed: { title: 'Invoiced', icon: <ReceiptText className='size-4' />, hint: 'Total of invoices sent to clients.' },
    settlements: { title: 'Settlements', icon: <Handshake className='size-4' />, hint: 'Total of all settlements posted.' },
    expenses: { title: 'Expenses', icon: <Receipt className='size-4' />, hint: 'Total of expenses billed on invoices.' },
    total: { title: 'Total', icon: <Coins className='size-4' />, hint: 'Total of all invoices in this view.' },
};

/**
 * `tiles` picks which totals to show, in order; each key is read from
 * paymentData. The dashboard shows Settlements / Due / Expenses (OL-141), the
 * invoice list and report keep Paid / Due / Invoiced.
 */
const InvoiceBillingSummary = ({ paymentData, loading, showTotalBlock = false, tiles = ['paid', 'due', 'billed'] }) => {
    const keys = showTotalBlock ? [...tiles, 'total'] : tiles;

    return (
        <div className='flex items-center justify-between max-sm:flex-wrap gap-2.5 mb-2'>
            {keys.map((key) => (
                <div className={`card sm:w-1/3 w-full`} key={key} title={TILES[key].hint}>
                    <div className={`w-full ${showTotalBlock ? 'px-3' : ''} card-body flex items-center justify-between text-base`}>
                        <div className='flex items-center gap-1.5'>
                            {TILES[key].icon}
                            {TILES[key].title}
                        </div>
                        <div>
                            {loading ? 
                            <Skeleton className='w-[75px] h-[14px]' />
                            :
                            formatCurrency(paymentData?.[key])
                            }
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export { InvoiceBillingSummary }
